/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading races…`)
};

const es_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando carreras…`)
};

const de_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rennen werden geladen…`)
};

const nl_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Races worden geladen…`)
};

const fr_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des courses…`)
};

const it_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento gare…`)
};

const pt_br2_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando corridas…`)
};

const pt_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar corridas…`)
};

const ja_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レースを読み込み中…`)
};

const zh_f1_loading_races = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载比赛…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_loading_races = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_loading_races(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_loading_races", locale)
	if (locale === "en") return en_f1_loading_races(inputs)
	if (locale === "es") return es_f1_loading_races(inputs)
	if (locale === "de") return de_f1_loading_races(inputs)
	if (locale === "nl") return nl_f1_loading_races(inputs)
	if (locale === "fr") return fr_f1_loading_races(inputs)
	if (locale === "it") return it_f1_loading_races(inputs)
	if (locale === "pt-BR") return pt_br2_f1_loading_races(inputs)
	if (locale === "pt") return pt_f1_loading_races(inputs)
	if (locale === "ja") return ja_f1_loading_races(inputs)
	return zh_f1_loading_races(inputs)
};